/** Profile loading and post-survey rewards must agree on every product entry. */
const PRODUCT_ROUTES = [
  '/explore', '/inspiration', '/template-library', '/kagemane', '/hypit',
  '/p', '/director-board', '/visual-editor', '/publishing', '/recents',
];

export function isOnboardingProductRoute(pathname: string): boolean {
  return PRODUCT_ROUTES.some(prefix => pathname === prefix || pathname.startsWith(`${prefix}/`));
}
